import React, { Component, PropTypes } from 'react';
import IngredientsSearchFilterSection from 'components/IngredientsSearch/IngredientsSearchFilterSection';
import {
  purchasedWithinOptions,
  filterSectionTypes,
  ingredientsSearchTabs,
  ingredientsSearchFilters,
  listDropDownDefault,
} from 'constants/ingredientsSearch';

class IngredientsSearchFilters extends Component {
  constructor() {
    super();
    this.state = {
      isPurchasedWithinCollapsed: false,
      isListDropDownCollapsed: false,
      isCategoryCollapsed: false,
      isBrandCollapsed: false,
      isPackSizeCollapsed: false,
      isStockTypeCollapsed: false,
    };
  }

  handleClickPurchasedWithinCollapse = () => {
    this.setState(prevState => ({
      isPurchasedWithinCollapsed: !prevState.isPurchasedWithinCollapsed,
    }));
  };

  handleClickisListDropDownCollapsed = () => {
    this.setState(prevState => ({
      isListDropDownCollapsed: !prevState.isListDropDownCollapsed,
    }));
  };

  handleClickCategoryCollapse = () => {
    this.setState(prevState => ({
      isCategoryCollapsed: !prevState.isCategoryCollapsed,
    }));
  };

  handleClickBrandCollapse = () => {
    this.setState(prevState => ({
      isBrandCollapsed: !prevState.isBrandCollapsed,
    }));
  };

  handleClickPackSizeCollapse = () => {
    this.setState(prevState => ({
      isPackSizeCollapsed: !prevState.isPackSizeCollapsed,
    }));
  };

  handleClickStockTypeCollapse = () => {
    this.setState(prevState => ({
      isStockTypeCollapsed: !prevState.isStockTypeCollapsed,
    }));
  };
  /**
   * remove Unspecified option from the facet list
   * @param {Array} checkBoxesOptions
   */
  removeUnspecifiedFacets = (checkBoxesOptions) => {
    return checkBoxesOptions.filter(item => item.name !== 'Unspecified');
  };

  handleClickCollapse = (filterSection) => {
    switch (filterSection) {
      case ingredientsSearchFilters.PURCHASED_WITHIN.id:
        return this.handleClickPurchasedWithinCollapse();
      case ingredientsSearchFilters.LIST_NAME.id:
        return this.handleClickisListDropDownCollapsed();
      case ingredientsSearchFilters.CATEGORY.id:
        return this.handleClickCategoryCollapse();
      case ingredientsSearchFilters.BRAND.id:
        return this.handleClickBrandCollapse();
      case ingredientsSearchFilters.PACK_SIZE.id:
        return this.handleClickPackSizeCollapse();
      case ingredientsSearchFilters.STOCK_TYPE.id:
        return this.handleClickStockTypeCollapse();
      default:
        return null;
    }
  };

  getListNames = (values) => {
    return [listDropDownDefault, ...values.map(item => ({ value: item.id, label: item.name }))];
  };

  isSectionCollapsed = (filterSection) => {
    const {
      isPurchasedWithinCollapsed,
      isListDropDownCollapsed,
      isCategoryCollapsed,
      isBrandCollapsed,
      isPackSizeCollapsed,
      isStockTypeCollapsed,
    } = this.state;

    switch (filterSection) {
      case ingredientsSearchFilters.PURCHASED_WITHIN.id:
        return isPurchasedWithinCollapsed;
      case ingredientsSearchFilters.LIST_NAME.id:
        return isListDropDownCollapsed;
      case ingredientsSearchFilters.CATEGORY.id:
        return isCategoryCollapsed;
      case ingredientsSearchFilters.BRAND.id:
        return isBrandCollapsed;
      case ingredientsSearchFilters.PACK_SIZE.id:
        return isPackSizeCollapsed;
      case ingredientsSearchFilters.STOCK_TYPE.id:
        return isStockTypeCollapsed;
      default:
        return null;
    }
  };

  render() {
    const {
      isPurchasedWithinCollapsed,
      isListDropDownCollapsed,
    } = this.state;
    const {
      selectedTab,
      fetchPurchaseHistory,
      fetchListIngredient,
      ingredientsSearch,
      changeFilterStatus,
      selectedFilters,
    } = this.props;

    // decide initially visible count for checkboxes for each Tab
    const initiallyVisibleCount = 4;

    return (
      <div className={ 'filters-wrapper' }>
        <h4 className='filters-heading'>Filters</h4>
        <div className={ 'filters-list' }>
          {
            selectedTab === ingredientsSearchTabs.PURCHASE_HISTORY_TAB.key ?
              <IngredientsSearchFilterSection
                sectionType={ filterSectionTypes.DROP_DOWN }
                sectionHeading={ ingredientsSearchFilters.PURCHASED_WITHIN.name }
                isCollapsed={ isPurchasedWithinCollapsed }
                handleClickCollapse={ () => this.handleClickCollapse(ingredientsSearchFilters.PURCHASED_WITHIN.id) }
                dropDownOptions={ purchasedWithinOptions }
                dropDownDefaultValue={ purchasedWithinOptions[0] }
                dropDownIsSearchable={ false }
                dropDownClassNamePrefix={ 'ss-dropdown' }
                dropDownOnChange={ fetchPurchaseHistory }
              /> : null
          }
          {
            ingredientsSearch[selectedTab].facets &&
            ingredientsSearch[selectedTab].facets.map(facet => {
              if (facet.values.length === 0) return null;
              return selectedTab === ingredientsSearchTabs.ITEM_LISTS_TAB.key && facet.id === 'LIST_NAME' ?
                <IngredientsSearchFilterSection
                  sectionType={ filterSectionTypes.DROP_DOWN }
                  sectionHeading={ ingredientsSearchFilters.LIST_NAME.name }
                  isCollapsed={ isListDropDownCollapsed }
                  handleClickCollapse={ () => this.handleClickCollapse(
                    ingredientsSearchFilters.LIST_NAME.id) }
                  dropDownOptions={ this.getListNames(facet.values) }
                  dropDownDefaultValue={ listDropDownDefault }
                  dropDownIsSearchable={ false }
                  dropDownClassNamePrefix={ 'ss-dropdown' }
                  dropDownOnChange={ fetchListIngredient }
                  key={ facet.id }
                /> :
                <IngredientsSearchFilterSection
                  sectionType={ filterSectionTypes.CHECK_BOXES }
                  sectionHeading={ facet.displayName }
                  isCollapsed={ this.isSectionCollapsed(facet.id) }
                  handleClickCollapse={ () => this.handleClickCollapse(facet.id) }
                  checkBoxesOptions={ this.removeUnspecifiedFacets(facet.values) }
                  initiallyVisibleCount={ initiallyVisibleCount }
                  checkBoxesSelectedOptions={ selectedFilters[facet.id] || [] }
                  changeFilterStatus={ changeFilterStatus }
                  facetId={ facet.id }
                  key={ facet.id }
                />;
            })
          }
{/*
          <IngredientsSearchFilterSection
            sectionType={ filterSectionTypes.RADIO_BUTTONS }
            sectionHeading={ ingredientsSearchFilters.STOCK_TYPE }
            isCollapsed={ isStockTypeCollapsed }
            handleClickCollapse={ this.handleClickStockTypeCollapse }
            initiallyVisibleCount={ initiallyVisibleCount }
            radioButtonsOptions={ ingredientsSearch[selectedTab].facets[3].values }
            radioButtonsSelectedOptions={ selectedFilters[facet.id] }
            changeFilterStatus={ changeFilterStatus }
            facetId={ facet.id }
          /> 
*/}
          {
            selectedTab === ingredientsSearchTabs.BATCH_RECIPES_TAB.key ?
              <div className={'no-data-available left-align'}>
                No Filters Available
              </div> : null
          }
        </div>
      </div>
    );
  }
}

IngredientsSearchFilters.propTypes = {
  fetchPurchaseHistory: PropTypes.func,
  fetchListIngredient: PropTypes.func,
  ingredientsSearch: PropTypes.object,
  selectedTab: PropTypes.string,
  changeFilterStatus: PropTypes.func,
  selectedFilters: PropTypes.object,
};

export default IngredientsSearchFilters;
